import CommonModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import "./EmailTab.css";
import email_send from "../../asset/image/email_send.svg";
import LabelValueDisplay from '../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay';
import email_success from "../../asset/image/email_success.svg";
import email_fail from "../../asset/image/email_fail.svg";
import alert_icon from "../../asset/image/alert_icon.svg";

interface MsgraphTestmailDialogProps {
    msGraphTestemail: any;
    successFail: boolean;
    email: string;
    recMail: string;
    handleCancelSuccessFail: () => void;
}

const MsgraphTestmailDialog = (props: MsgraphTestmailDialogProps) => {
    const {msGraphTestemail, successFail, email, recMail, handleCancelSuccessFail} = props;

    const element = (
        <div className="padding10">
            {msGraphTestemail?.success == true && <img src={email_success} className="testmailStatusImage"></img>}
            {msGraphTestemail?.success == false && <img src={email_fail} className="testmailStatusImage"></img>}
            {msGraphTestemail?.success !== undefined && <div className="transfer-tab-grid">
                <LabelValueDisplay
                    label="From"
                    value={email}
                />
            </div>}
            {msGraphTestemail?.success !== undefined && <LabelValueDisplay
                label="To"
                value={recMail}
            />}
            {msGraphTestemail?.success == true && <div className="successFailText">The email has been successfully sent.</div>}
            {msGraphTestemail?.success == false && <div className="successFailText">The email could not be sent. Please try again later.</div>}
        </div>
    )
    return(
        <CommonModal
            open={(msGraphTestemail?.success !== undefined) && successFail}
            onClose={handleCancelSuccessFail}
            onSave={handleCancelSuccessFail}
            title={"Test Email"}
            saveText={"OK"}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"408px"}
            height={"321px"}
            showCancel={false}
            titleWithWarningIcon={msGraphTestemail?.success == true}
            titleWithCustomIcon={msGraphTestemail?.success == false}
            customIcon={alert_icon}
        />
    )
}

export default MsgraphTestmailDialog;